import { EditorState, Modifier, SelectionState } from 'draft-js';
import _ from 'lodash';

const CLASS_NAME = 'token-textarea';
const SECOND_LIST_CLASS_NAME = `${CLASS_NAME}-second-list`;
const WORKSPACE_CLASS_NAME = `${CLASS_NAME}-workspace`;

const getFirstFromEachGroup = groups => {
  const userGroups = [];
  _.each(groups, group => {
    userGroups.push(_.kebabCase(_.get(_.first(_.get(group, 'tokens')), 'name')));
  });
  return userGroups;
};

const creatBlock = (key, text, offset, keyOfRange) => ({
  key,
  text,
  type: 'unstyled',
  depth: 0,
  inlineStyleRanges: [],
  entityRanges: [
    {
      offset,
      length: text.length,
      key: keyOfRange,
    },
  ],
  data: {},
});

const createEntity = (keyOfRange, mention) => ({
  type: '[mention',
  mutability: 'IMMUTABLE',
  data: {
    mention,
  },
});

const messagesTokens = data => _.flatten(_.map(data, group => _.flatten(group.tokens)));

const formatTokens = data => {
  if (data) {
    return _.each(data, group =>
      _.each(group.tokens, token => {
        token.groupName = group.name;
        token.code = `%%${token.token}%%`;
      }),
    );
  }
  return [];
};

const tokensForReadOnly = message => {
  const GROUP_NAME = 'Custom';

  const result = {
    name: GROUP_NAME,
    tokens: [],
  };

  const tokens = message.match(/%%\w*%%/g);

  if (tokens) {
    _.each(tokens, token => {
      const tokenName = _.trim(token, '% ');
      result.tokens = [
        ...result.tokens,
        {
          code: `%%${tokenName}%%`,
          groupName: GROUP_NAME,
          name: _.capitalize(_.join(_.split(tokenName, '_'), ' ')),
          token: tokenName,
        },
      ];
    });
  }

  return [result];
};

const removeCharacterByRange = (editorState, blockKey, startOffset, endOffset, editContent) => {
  const content = editorState.getCurrentContent();
  const targetRange = new SelectionState({
    anchorKey: blockKey,
    anchorOffset: startOffset,
    focusKey: blockKey,
    focusOffset: endOffset,
  });

  const removeResult = Modifier.removeRange(content, targetRange, 'backward');
  const resetBlock = Modifier.setBlockType(
    removeResult,
    removeResult.getSelectionAfter(),
    'unstyled',
  );

  const newState = EditorState.push(editorState, resetBlock, 'remove-range');

  if (editContent) {
    return EditorState.forceSelection(newState, resetBlock.getSelectionAfter());
  }

  return newState;
};

const handleKeyCommand = (command, __, editorOptions) => {
  if (command === 'backspace') {
    const editorState = editorOptions.getEditorState();
    const getSelection = editorState.getSelection();
    const offsetStart = getSelection.getStartOffset();
    const offsetEnd = getSelection.getEndOffset();
    const selectionKey = getSelection.getAnchorKey();

    removeCharacterByRange(editorState, selectionKey, offsetStart, offsetEnd, true);
  }
};

export {
  CLASS_NAME,
  creatBlock,
  createEntity,
  formatTokens,
  getFirstFromEachGroup,
  handleKeyCommand,
  messagesTokens,
  removeCharacterByRange,
  SECOND_LIST_CLASS_NAME,
  tokensForReadOnly,
  WORKSPACE_CLASS_NAME,
};
